import { useNode, useEditor } from "@craftjs/core";
import React from "react";
import GrigoraCSSRenderer from "./../css-render";
import { FormCheckboxSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";

export const FormCheckbox = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    query: { node },
    actions: { selectNode },
  } = useEditor();

  const { options = [] } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-form-checkbox": true,
      [`form-checkbox-${id}`]: id,
    },
    blockProps.className,
  );

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__FormCheckbox(id, props)}`}</style>
      {options.length === 0 ? (
        <div className="checkbox-empty-container">
          <p>Add Checkbox</p>
        </div>
      ) : (
        options &&
        options.map((checkbox, i) => {
          return (
            <>
              <label className="form-checkbox-container">
                <input
                  key={`checkbox-${i}`}
                  name={checkbox.name ? checkbox.name : undefined}
                  className="form-input-checkbox"
                  type="checkbox"
                  onChange={(e) => {
                    setProp((props) => {
                      props.checked = e.target.checked;
                    });
                  }}
                />
                <span className="form-checkbox-label">{checkbox.label}</span>
              </label>
            </>
          );
        })
      )}
    </div>
  );
};

// To Avoid Mangling in Production
FormCheckbox.displayName = "FormCheckbox";

FormCheckbox.craft = {
  name: "Form Checkbox",
  props: {},
  related: {
    icon: icon,
    category: "form",
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    settings: FormCheckboxSettings,
    keywords: ["Form Checkbox", "Checkbox", "Tickmark Check"],
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "Form Checkbox",
    slug: "grigora/form-checkbox",
  },
};
